import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "common-table-component" }

import { onMounted, reactive, ref, toRef, toRefs, inject, watch, Ref, nextTick } from 'vue'
import { useTableMaxHeight } from '@/hooks/index'
import { debounce } from 'lodash-es'
import { TableData, ColumnItem } from '@/types/index'


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonTable',
  props: {
    tableData: { default: () => ({
      tableList: [],
      multipleSelection: [],
    }) },
    columnList: {},
    isShowIndex: { type: Boolean, default: false },
    isShowSelection: { type: Boolean, default: false },
    isShowOption: { type: Boolean, default: false },
    summaryMethod: {},
    loading: { type: Boolean, default: false },
    emptyText: {},
    optionColumnName: {},
    hightlightCurrentRow: { type: Boolean, default: false },
    border: { type: Boolean, default: false },
    headerCellStyle: { type: Boolean, default: true },
    stripe: { type: Boolean, default: true },
    maxHeight: {},
    tableRowClassName: {},
    tableHeaderRowClassName: {},
    cellClassName: {},
    headerCellClassName: {},
    spanMethod: {},
    optionColumnWidth: { default: 130 },
    selectable: {},
    defaultSort: {},
    rowKey: {},
    defaultExpandAll: { type: Boolean },
    useMaxHeight: { type: Boolean, default: true }
  },
  emits: ['dblClick', 'currentChange', 'selectionChange', 'rowClick', 'rowContextmenu', 'cellClick'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

let props = __props

const emit = __emit

let { tableData, columnList } = toRefs(props)
let tableRef = ref()

__expose({
  tableRef,
})

// 勾选
const handleSelect = (selection: any[], row: any) => {
  // console.log('handleSelect', selection, row)
  // 单选时，自动取消之前的选择
  if (props.hightlightCurrentRow) {
    tableData.value.multipleSelection = [row]
    tableRef.value?.clearSelection()
    tableRef.value?.toggleRowSelection(row, true)
  }
}
// 全选
const handleSelectAll = (selection: any[]) => {
  // console.log('handleSelectAll', selection)
  // 单选时，禁止自带的全选功能
  if (props.hightlightCurrentRow) {
    tableRef.value?.clearSelection()
    if (tableData.value.multipleSelection?.length) {
      tableRef.value?.toggleRowSelection(tableData.value.multipleSelection[0], true)
    }
  }
}
// 多选-选项改变
const handleSelectionChange = (val: any[]) => {
  // console.log('selection-change', val)
  if (!props.hightlightCurrentRow) {
    tableData.value.multipleSelection = val
  }
  emit('selectionChange')
}
// 单选
const handleCurrentChange = (currentRow: any, oldCurrentRow: any) => {
  // console.log('handleCurrentChange--')
  // 单选时，自动更新复选框选中状态
  if (props.hightlightCurrentRow) {
    tableData.value.multipleSelection = [currentRow]
    tableRef.value?.clearSelection()
    tableRef.value?.toggleRowSelection(currentRow, true)
  }
  emit('currentChange')
}
// 单击行
const handleRowClick = (row, column, event) => {
  // console.log('handleRowClick--')
  // 单选时，自动更新复选框选中状态
  if (props.hightlightCurrentRow) {
    tableData.value.multipleSelection = [row]
    tableRef.value?.clearSelection()
    tableRef.value?.toggleRowSelection(row, true)
  }
  emit('rowClick', row)
}
// 双击行
const handleDblClick = (row: any) => {
  emit('dblClick', row)
}
// 右击行
const handleRowContextmenu = (row, column, event) => {
  event.preventDefault()
  emit('rowContextmenu', { row, column, event })
}
// 单击单元格
const handleCellClick = (row, column, cell, event) => {
  // console.log('handleCellClick--')
  emit('cellClick', { row, column, cell, event })
}

let maxHeight = ref(props.useMaxHeight ? props.maxHeight ?? 600 : undefined)

// 多层嵌套的 CommonTable 组件，在适当的时机重新获取 maxHeight，上传组件 provide 注入响应式变量
let tableIsShow: Ref<boolean> = inject('tableIsShow', ref(false))
watch(
  () => tableIsShow?.value,
  debounce(newValue => {
    if (newValue === true) {
      nextTick(() => {
        if (!props.maxHeight && props.useMaxHeight) {
          maxHeight.value = useTableMaxHeight()
        }
      })
    }
  }, 50),
)

onMounted(() => {
  if (!props.maxHeight && props.useMaxHeight) {
    maxHeight.value = useTableMaxHeight() //组件 mounted 但可能并未显示，基于 document.querySelector('.el-table') 计算的高度可能出错
    // console.log('mounted--', maxHeight.value)
    window.addEventListener(
      'resize',
      debounce(() => {
        maxHeight.value = useTableMaxHeight()
      }, 150),
    )
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref_key: "tableRef",
      ref: tableRef,
      data: _unref(tableData).tableList,
      stripe: _unref(props).stripe,
      "max-height": _unref(maxHeight),
      "header-cell-style": _unref(props).headerCellStyle ? { background: '#EBF3FE', color: '#333' } : undefined,
      "show-summary": !!_unref(props).summaryMethod,
      "summary-method": !!_unref(props).summaryMethod ? _unref(props).summaryMethod : undefined,
      "highlight-current-row": _unref(props).hightlightCurrentRow,
      onSelect: handleSelect,
      onSelectAll: handleSelectAll,
      onSelectionChange: handleSelectionChange,
      onCurrentChange: handleCurrentChange,
      onRowDblclick: handleDblClick,
      onRowClick: handleRowClick,
      onRowContextmenu: handleRowContextmenu,
      onCellClick: handleCellClick,
      "row-class-name": _unref(props).tableRowClassName,
      "header-row-class-name": _unref(props).tableHeaderRowClassName,
      "cell-class-name": _unref(props).cellClassName,
      "header-cell-class-name": _unref(props).headerCellClassName,
      "span-method": _unref(props).spanMethod,
      style: _normalizeStyle(_unref(maxHeight) ? { 'max-height': _unref(maxHeight) + 'px' } : undefined),
      "empty-text": _unref(props).emptyText,
      border: _unref(props).border,
      "default-sort": __props.defaultSort,
      "row-key": _unref(props).rowKey,
      "default-expand-all": _unref(props).defaultExpandAll
    }, {
      default: _withCtx(() => [
        (!!_unref(props).isShowIndex)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              type: "index",
              width: "55"
            }))
          : _createCommentVNode("", true),
        (!!_unref(props).isShowSelection)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              selectable: __props.selectable,
              type: "selection",
              width: "55"
            }, null, 8, ["selectable"]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columnList), (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            key: index,
            prop: item.prop,
            label: item.label,
            "min-width": item.minWidth || 110,
            width: item.width || undefined,
            sortable: item.sortable,
            "show-overflow-tooltip": item.showOverflowTooltip != null ? item.showOverflowTooltip : true,
            fixed: 'fixed' in item ? item.fixed : false
          }, _createSlots({
            default: _withCtx(() => [
              (item.children?.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.children, (subItem, subIndex) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      key: subIndex,
                      prop: subItem.prop,
                      label: subItem.label,
                      "min-width": subItem.minWidth || 110,
                      width: subItem.width || undefined,
                      "show-overflow-tooltip": subItem.showOverflowTooltip != null ? subItem.showOverflowTooltip : true
                    }, _createSlots({ _: 2 }, [
                      (subItem.headerSlotName)
                        ? {
                            name: "header",
                            fn: _withCtx((scope) => [
                              _createTextVNode(_toDisplayString(subItem.label) + " ", 1),
                              (subItem.headerSlotName)
                                ? _renderSlot(_ctx.$slots, subItem.headerSlotName, _mergeProps({
                                    key: 0,
                                    ref_for: true
                                  }, scope))
                                : _createCommentVNode("", true)
                            ]),
                            key: "0"
                          }
                        : undefined,
                      (subItem.slotName)
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              (subItem.slotName)
                                ? _renderSlot(_ctx.$slots, subItem.slotName, _mergeProps({
                                    key: 0,
                                    ref_for: true
                                  }, scope))
                                : _createCommentVNode("", true)
                            ]),
                            key: "1"
                          }
                        : undefined
                    ]), 1032, ["prop", "label", "min-width", "width", "show-overflow-tooltip"]))
                  }), 128))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, [
            (item.headerSlotName)
              ? {
                  name: "header",
                  fn: _withCtx((scope) => [
                    _createTextVNode(_toDisplayString(item.label) + " ", 1),
                    (item.headerSlotName)
                      ? _renderSlot(_ctx.$slots, item.headerSlotName, _mergeProps({
                          key: 0,
                          ref_for: true
                        }, scope))
                      : _createCommentVNode("", true)
                  ]),
                  key: "0"
                }
              : undefined,
            (item.slotName)
              ? {
                  name: "default",
                  fn: _withCtx((scope) => [
                    (item.slotName)
                      ? _renderSlot(_ctx.$slots, item.slotName, _mergeProps({
                          key: 0,
                          ref_for: true
                        }, scope))
                      : _createCommentVNode("", true)
                  ]),
                  key: "1"
                }
              : undefined
          ]), 1032, ["prop", "label", "min-width", "width", "sortable", "show-overflow-tooltip", "fixed"]))
        }), 128)),
        (_unref(props).isShowOption)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              "min-width": __props.optionColumnWidth,
              label: _unref(props).optionColumnName || '操作',
              fixed: "right"
            }, {
              default: _withCtx((scope) => [
                _renderSlot(_ctx.$slots, "optionColumn", _normalizeProps(_guardReactiveProps(scope)))
              ]),
              _: 3
            }, 8, ["min-width", "label"]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["data", "stripe", "max-height", "header-cell-style", "show-summary", "summary-method", "highlight-current-row", "row-class-name", "header-row-class-name", "cell-class-name", "header-cell-class-name", "span-method", "style", "empty-text", "border", "default-sort", "row-key", "default-expand-all"])), [
      [_directive_loading, _unref(props).loading]
    ])
  ]))
}
}

})